import { Component, EventEmitter, Input, OnInit, Output, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { DividerModule } from 'primeng/divider';
import { MessageService } from 'primeng/api';
import { NGXLogger } from 'ngx-logger';
import { Richiesta } from '../../../models/richiesta.model';
import { RichiesteService } from '../../../services/richieste.service';
import { StiliService } from '../../../services/stili.service';
import { Table, TableModule } from 'primeng/table';
import { InterventiService } from '../../../services/interventi.service';
import { TooltipModule } from 'primeng/tooltip';
import { Intervento } from '../../../models/intervento.model';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DropdownModule } from 'primeng/dropdown';
import { StepsModule } from 'primeng/steps';
import { SchedeService } from '../../../services/schede.service';
import { Scheda } from '../../../models/scheda.model';
import { TipoIntervento } from '../../../models/tipo-intervento.model';
import { MenuItem } from 'primeng/api';
import { StatoRichiesta } from '../../../models/stato-richiesta.model';
import { AggiungiInterventoComponent } from './aggiungi-intervento/aggiungi-intervento.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CreaVarianteRichiestaDTO } from '../../../models/requests/crea-variante-richiesta.model';

@Component({
  selector: 'app-variante',
  templateUrl: './variante.component.html',
  styleUrls: ['./variante.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule,
    ToastModule,
    DividerModule,
    TableModule,
    TooltipModule,
    InputNumberModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    InputTextareaModule,
    DropdownModule,
    StepsModule,
    AggiungiInterventoComponent,
    DialogModule
  ],
  providers: [MessageService, DialogService]
})
export class VarianteComponent implements OnInit {
  @ViewChild('dt') dt!: Table;
  @ViewChild(AggiungiInterventoComponent) aggiungiInterventoComponent!: AggiungiInterventoComponent;

  @Input() visible: boolean = false;
  @Input() richiesta: Richiesta | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() varianteCreata = new EventEmitter<void>();

  varianteInCorso: boolean = false;
  interventi: Intervento[] = [];
  interventiOriginali: Intervento[] = [];
  interventiCaricati: boolean = false;
  interventoInModifica: Intervento | null = null;
  nuovoImportoFinanziato: number | null = null;

  // Proprietà per il filtro globale della tabella
  filtroTestoGlobale: string = '';

  // Proprietà per il nuovo intervento
  private fb = inject(FormBuilder);
  private schedaService = inject(SchedeService);
  private interventoService = inject(InterventiService);
  private messageService = inject(MessageService);
  public stiliService = inject(StiliService);

  // Proprietà per il dialog di nuovo intervento
  visibleNuovoIntervento = false;
  form!: FormGroup;
  activeIndex = 0;
  submitting = false;
  items: MenuItem[] = [
    {
      label: 'Scheda',
      icon: 'pi pi-fw pi-file'
    },
    {
      label: 'Dettagli',
      icon: 'pi pi-fw pi-pencil'
    }
  ];

  schede: Scheda[] = [];
  tipiIntervento: TipoIntervento[] = [];
  priorita = [
    { label: 'Alta', value: 1 },
    { label: 'Media', value: 2 },
    { label: 'Bassa', value: 3 },
  ];

  private dialogRef: DynamicDialogRef | undefined;

  loading = false;

  constructor(
    private logger: NGXLogger,
    private richiesteService: RichiesteService,
    private interventiService: InterventiService,
    private dialogService: DialogService
  ) {
    this.initForm();
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.form = this.fb.group({
      scheda: [null, Validators.required],
      tipoIntervento: [null, Validators.required],
      priorita: [null, Validators.required],
      note: ['']
    });
  }

  showNuovoIntervento() {
    this.visibleNuovoIntervento = true;
    this.activeIndex = 0;
    this.initForm();
    this.caricaSchede();
    this.caricaTipiIntervento();
  }

  hideNuovoIntervento() {
    this.visibleNuovoIntervento = false;
    this.form.reset();
  }

  caricaSchede(): void {
    this.schedaService.getSchede().subscribe({
      next: (data) => {
        this.schede = data;
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore nel caricamento delle schede'
        });
      }
    });
  }

  caricaTipiIntervento(): void {
    this.interventoService.getTipiIntervento().subscribe({
      next: (data) => {
        this.tipiIntervento = data;
        if (this.tipiIntervento && this.tipiIntervento.length > 0) {
          this.form.get('tipoIntervento')?.setValue(this.tipiIntervento.find(t => t.codice === 'MO'));
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore nel caricamento dei tipi di intervento'
        });
      }
    });
  }

  aggiungiIntervento() {
    this.aggiungiInterventoComponent.show();
  }
  onInterventoAggiunto(intervento: Intervento) {
    this.logger.info('[VARIANTE] Intervento aggiunto', intervento, ' erano ' + this.interventi.length + ' interventi');
    this.interventi.push(intervento);
    this.interventi = [...this.interventi];
    this.interventiCaricati = true;
    this.logger.info('[VARIANTE] Intervento aggiunto', intervento, ' sono ' + this.interventi.length + ' interventi');
  }

  hide() {
    this.visible = false;
    this.visibleChange.emit(false);
    // Pulisce tutti i campi quando il dialog viene chiuso
    this.reset();
  }

  reset() {
    // Pulisce il filtro
    this.pulisciFiltroGlobale();
    // Pulisce i campi di modifica
    this.interventoInModifica = null;
    this.nuovoImportoFinanziato = null;
    // Pulisce gli interventi
    this.interventi = [];
    this.interventiOriginali = [];
    this.interventiCaricati = false;
  }

  loadInterventi() {
    if (!this.richiesta?.id) return;

    this.interventiCaricati = false;
    this.interventoService.getInterventiRichiestaPerVariante(this.richiesta.id.toString()).subscribe({
      next: (interventi: Intervento[]) => {
        this.interventi = interventi;
        this.interventiOriginali = JSON.parse(JSON.stringify(interventi));
        this.interventiCaricati = true;
      },
      error: (error: Error) => {
        this.logger.error('[VARIANTE] Errore durante il caricamento degli interventi', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Si è verificato un errore durante il caricamento degli interventi'
        });
      },
      complete: () => {
        this.interventiCaricati = true;
      }
    });
  }

  modificaImportoFinanziato(intervento: Intervento) {
    this.interventoInModifica = intervento;
    this.nuovoImportoFinanziato = intervento.importoFinanziato;
  }

  salvaModificaImporto(intervento: Intervento) {
    this.logger.info('[VARIANTE] Salva modifica importo', this.nuovoImportoFinanziato);
    const index = this.interventi.findIndex(i => i.id === intervento.id);
    if (index !== -1 && this.nuovoImportoFinanziato !== null) {
      this.interventi[index].importoFinanziato = this.nuovoImportoFinanziato;
      this.interventi = [...this.interventi];
      this.interventoInModifica = null;
      this.nuovoImportoFinanziato = 0;
    }
  }

  creaVariante() {
    if (!this.richiesta) return;

    this.varianteInCorso = true;
    this.logger.info('[VARIANTE] Avvio creazione variante', this.richiesta);

    // Interventi con importo finanziato modificato
    const interventiModificati = this.interventi.filter(intervento => {
      const interventoOriginale = this.interventiOriginali.find(i => i.id === intervento.id);
      return interventoOriginale && interventoOriginale.importoFinanziato !== intervento.importoFinanziato;
    });

    // Nuovi interventi (quelli senza id)
    const nuoviInterventi = this.interventi.filter(intervento => !intervento.id);

    if (interventiModificati.length === 0 && nuoviInterventi.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Attenzione',
        detail: 'Non sono state apportate modifiche'
      });
      this.varianteInCorso = false;
      return;
    }

    const payload: CreaVarianteRichiestaDTO = {
      idRichiesta: this.richiesta.id,
      importoFinanziato: this.getTotaleImportiFinanziati(),
      interventiModificati: interventiModificati,
      nuoviInterventi: nuoviInterventi
    };

      this.richiesteService.creaVariante(this.richiesta.id, payload).subscribe({
      next: () => {
        this.logger.info('[VARIANTE] Variante creata con successo');
        this.messageService.add({
          severity: 'success',
          summary: 'Variante richiesta ' + this.richiesta?.anno,
          detail: 'Variante creata con successo'
        });
        this.varianteCreata.emit();
        this.hide();
      },
      error: (error: Error) => {
        this.logger.error('[VARIANTE] Errore durante la creazione della variante', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Si è verificato un errore durante la creazione della variante'
        });
      },
      complete: () => {
        this.varianteInCorso = false;
      }
    });
  }

  show(richiesta: Richiesta) {
    this.richiesta = richiesta;
    this.visible = true;
    // Pulisce tutti i campi quando il dialog viene aperto
    this.reset();
    this.loadInterventi();
  }

  onInputChange(value: any) {
    this.nuovoImportoFinanziato = typeof value === 'number' ? value : null;
  }

  azzeraImportoFinanziato(intervento: Intervento) {
    const index = this.interventi.findIndex(i => i.id === intervento.id);
    if (index !== -1) {
      this.interventi[index].importoFinanziato = 0;
      this.interventi = [...this.interventi];
      this.interventoInModifica = null;
    }
  }

  getTotaleImportiFinanziati(): number {
    return this.interventi.reduce((totale, intervento) => totale + (intervento.importoFinanziato || 0), 0);
  }

  // Metodi per il filtro globale della tabella
  pulisciFiltroGlobale() {
    this.filtroTestoGlobale = '';
    if (this.dt) {
      this.dt.filterGlobal('', 'contains');
    }
  }

  onFiltroGlobaleChange(event: Event) {
    if (this.dt) {
      // Casting esplicito di event.target a HTMLInputElement per accedere a value
      const inputValue = (event.target as HTMLInputElement).value;
      this.dt.filterGlobal(inputValue, 'contains');
    }
  }

}
